import * as React from 'react'
import { LoginScreen } from '../screens/LoginScreen/LoginScreen'
import { PasswordRecoveryFirstScreen } from '../screens/PasswordRecoveryScreens/PasswordRecoveryFirstScreen'
import { PasswordRecoverySecondScreen } from '../screens/PasswordRecoveryScreens/PasswordRecoverySecondScreen'
import { FirstLoginScreen } from '../screens/LoginScreen/FirstLoginScreen'
import { RedefinePasswordScreen } from '../screens/RedefinePasswordScreens/RedefinePasswordScreen'
import { AuthLoadingScreen } from '../screens/AuthLoadingScreen'
import { SignUpScreen } from '../screens/SignUp/SignUpScreen'
import { VerificationScreen } from '../screens/SignUp/VerificationScreen'

export const ScreensAuth = 'screens.auth.'

export const AuthStackScreenNames = {
  FirstLogin: 'FirstLogin',
  Login: 'Login',
  SignUp: 'SignUp',
  SignUpVerification: 'SignUpVerification',
  PasswordRecovery: 'PasswordRecovery',
  RedefinePassword: 'RedefinePassword',
  SecondPasswordRecoveryScreen: 'SecondPasswordRecoveryScreen',
  AuthLoading: 'AuthLoading',
}

export const AuthStack = Stack => [
  <Stack.Screen
    key={`${ScreensAuth}${AuthStackScreenNames.AuthLoading}`}
    name={AuthStackScreenNames.AuthLoading}
    component={AuthLoadingScreen}
    options={AuthLoadingScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${AuthStackScreenNames.Login}`}
    name={AuthStackScreenNames.Login}
    component={LoginScreen}
    options={LoginScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${AuthStackScreenNames.SignUp}`}
    name={AuthStackScreenNames.SignUp}
    component={SignUpScreen}
    options={SignUpScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${AuthStackScreenNames.SignUpVerification}`}
    name={AuthStackScreenNames.SignUpVerification}
    component={VerificationScreen}
    options={VerificationScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${AuthStackScreenNames.FirstLogin}`}
    name={AuthStackScreenNames.FirstLogin}
    component={FirstLoginScreen}
    options={FirstLoginScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${AuthStackScreenNames.PasswordRecovery}`}
    name={AuthStackScreenNames.PasswordRecovery}
    component={PasswordRecoveryFirstScreen}
    options={PasswordRecoveryFirstScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${AuthStackScreenNames.SecondPasswordRecoveryScreen}`}
    name={AuthStackScreenNames.SecondPasswordRecoveryScreen}
    component={PasswordRecoverySecondScreen}
    options={PasswordRecoverySecondScreen.navigationOptions}
  />,
  <Stack.Screen
    key={`${ScreensAuth}${AuthStackScreenNames.RedefinePassword}`}
    name={AuthStackScreenNames.RedefinePassword}
    component={RedefinePasswordScreen}
    options={RedefinePasswordScreen.navigationOptions}
  />,
]
